import { JSX } from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    TextInput,
    ShowButton,
    TopToolbar,
    CreateButton,
    ExportButton,
    FilterButton,
    EmailField,
    ReferenceField
} from 'react-admin';

const contactFilters: JSX.Element[] = [
    <TextInput label="Id" source="id" name="Id" />,
    <TextInput label="Account holder (exact name)" source="accountHolder.name" name="accountHolder.name" />,
    <TextInput label="Account holder email" source="accountHolder.email" name="accountHolder.email" />
];

const ListActions: () => JSX.Element = (): JSX.Element => {
    return(
        <TopToolbar>
            <CreateButton />
            {/*<FilterButton />*/}
            {/*<ExportButton />*/}
        </TopToolbar>
    );
}

export const CustomerAccountList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={ <ListActions /> }
            filters={ contactFilters }>
            {/* Off, like the other 43 lists. It was on here only because nothing said otherwise, and
                what it offered was a bulk delete with no confirmation and no permission check:
                `BulkDeleteButton` does not ask `canAccess`. Deleting one record at a time from
                its own form still works, and asks first. */}
            <Datagrid bulkActionButtons={ false }>
                <TextField source="id" />
                <ReferenceField source="accountHolder" reference="customers" />
                {/*<TextField source="name" />*/}
                {/*<TextField source="email" />*/}
                <>
                    <EditButton />
                </>
            </Datagrid>
        </List>
    );

}
